import { apiClient } from './ApiClient';
import { API_ENDPOINTS } from '../../shared/constants';
import { ApiResponse, ProductApiData } from '../../shared/types';
import { Product } from '../../domain/entities';

export class ProductApi {
    static async fetchByVehicleId(vehicleId: number, token: string): Promise<Product[]> {
        try {
            const response = await apiClient.get<ApiResponse<ProductApiData[]>>(
                API_ENDPOINTS.products(vehicleId),
                token
            );

            if (!response.success || !response.data) {
                return [];
            }

            return response.data.map(item => Product.fromAPI(item));
        } catch (error) {
            console.error('Error fetching products:', error);
            return [];
        }
    }
}

